export const reteynerSelectionSet = [
  "id",
  "organisationId",
  "publications.publication.*",
  "topics.*",
  "topics.questions.*",
  "topics.questions.answers.*",
] as const;
